/**
 * An open-source package in the client bundle, with its license.
 */
export interface OssPackage {
  name: string
  version: string
  license: string
  text: string
  repository?: string
}

/**
 * Fetches the license list that production builds write. Resolves to `null`
 * when the list is not there.
 */
export async function fetchOssLicenses(
  signal?: AbortSignal,
): Promise<OssPackage[] | null> {
  const response = await fetch('/oss-licenses.json', { signal })
  if (!response.ok) {
    return null
  }

  return (response.json() as Promise<OssPackage[]>).catch(() => null)
}
